import { MediumThought } from "./props";

const mediumThoughts: MediumThought[] = [
  {
    title: "The Fitness Experiment That Changed How I See Myself",
    description:
      "What a fitness experiment taught me about consistency, patience, and how I see myself.",
    date: "Aug 29, 2026",
    url: "https://fide11s.medium.com/the-fitness-experiment-that-changed-how-i-see-myself-f922d9b9ac5c",
  },
  {
    title: "How April taught me in 2026",
    description:
      "What an ordinary month revealed about attention, uncertainty, and staying present.",
    date: "Apr 30, 2026",
    url: "https://fide11s.medium.com/how-april-taught-me-in-2026-d76d5ea031ea",
  },
  {
    title: "Rewiring My Reward System — Taught by My Dog 🐶",
    description:
      "A story about habits, rewards, and an unexpected lesson I noticed while living with my dog.",
    date: "Jun 14, 2025",
    url: "https://fide11s.medium.com/rewiring-my-reward-system-taught-by-my-dog-015cdbcc6b74",
  },
  {
    title: "Participate as an Introvert",
    description:
      "A reflection on taking part without pretending to be louder than I am.",
    date: "Jun 9, 2025",
    url: "https://fide11s.medium.com/participate-as-an-introvert-b26fb26d7fd6",
  },
];

export default mediumThoughts;
